/* eslint-disable sort-keys-fix/sort-keys-fix -- CSS-in-JS pseudo-selector keys use semantic ordering */
// MUI v4 Toolbar — NS/Tractie component overrides.
// All MUI v4 style classes are declared explicitly (no implicit inheritance on MUI defaults).
// Tractie deviations: explicit min-heights for regular (64) en dense (48), Tractie inset-m
// gutters (16px) ipv MUI's responsive 16/24, no transition.

export const MuiToolbarLightOverrides = {
  root: {
    position: 'relative' as const,
    display: 'flex' as const,
    alignItems: 'center' as const,
    transition: 'none',
  },

  gutters: {
    paddingLeft: 16,
    paddingRight: 16,
  },

  regular: {
    minHeight: 64,
  },

  dense: {
    minHeight: 48,
  },
} as const;

// Dark palette variant — Toolbar is structureel; geen mode-specific overrides nodig.
export const MuiToolbarDarkOverrides = {
  ...MuiToolbarLightOverrides,
} as const;
